import EfIcon from '@elem/ui/ef-icon';
import EfTitle from '@elem/ui/ef-title';
import { useEffect, useState } from 'react';
import { useProductStore } from '../../ProductProvider';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp({ PRODUCT_TM, PRODUCT_OTHER }: any) {
    const { t } = useLang('theProduct.OtherB');
    const [enterA, setEnterA] = useState(false);
    const { pageType } = useProductStore();

    useEffect(() => {
        const sceneEnterA = AniContainer.create({
            triggerElement: '#OtherB-id1',
            triggerHook: 1,
            offset: 300,
            duration: '220%',
            onEnter: () => setEnterA(true),
            onLeave: () => setEnterA(false),
        });
    }, []);
    return (
        <div className={styles.TheComp} id="OtherB-id1">
            <EfTitle>{t('title')}</EfTitle>
            <div className={`ef-container OtherB-in${enterA ? ' OtherB-enterA' : ''}`}>
                <div className={`OtherB-item OtherB-item1 ${pageType === PAGE_TYPE.BASE ? 'base' : 'tm'}`}>
                    <div className="OtherB-item-line1">
                        <EfIcon className="OtherB-item-icon" pc={PRODUCT_TM} />
                        <span className="OtherB-item-line1-ms">{t('a_text1')}</span>
                    </div>
                    <div className="OtherB-item-line2">
                        <div className="OtherB-item-line2-bar"></div>
                        <div className="OtherB-item-line2-msg">
                            <div className="OtherB-item-line2-text2">{t('a_text2')}</div>
                            <div className="OtherB-item-line2-text3">{t('a_text3')}</div>
                        </div>
                    </div>
                </div>
                <div className="OtherB-item OtherB-item2">
                    <div className="OtherB-item-line1">
                        <EfIcon className="OtherB-item-icon" pc={PRODUCT_OTHER} />
                        <span className="OtherB-item-line1-ms">{t('b_text1')}</span>
                    </div>
                    <div className="OtherB-item-line2">
                        <div className="OtherB-item-line2-bar"></div>
                        <div className="OtherB-item-line2-msg">
                            <div className="OtherB-item-line2-text2">{t('b_text2')}</div>
                            <div className="OtherB-item-line2-text3">{t('b_text3')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
